const menuEventTypes = [
  {
    id: 2,
    name: 'イベントメニューの対象'
  },
  {
    id: 1,
    name: '全グループの対象'
  }
];
export default menuEventTypes;
